import React, { useEffect, useState } from 'react';
import { Bell } from 'lucide-react';
import { toast } from 'sonner';
import { calendarsAPI } from '../lib/api';

const LABEL = { 0: 'Sin aviso', 15: '15 min antes', 30: '30 min antes', 60: '1 hora antes' };

export const EventReminderSelect = () => {
  const [value, setValue] = useState(null);
  useEffect(() => { calendarsAPI.getReminderSettings().then((r) => setValue(r.minutos)).catch(() => {}); }, []);
  if (value === null) return null;
  const change = async (v) => {
    const prev = value; setValue(v);
    try { await calendarsAPI.setReminderSettings(v); toast.success(v ? `Avisaremos ${LABEL[v].toLowerCase()} de cada evento` : 'Avisos antes de los eventos desactivados'); }
    catch (e) { setValue(prev); toast.error(e.message || 'No se pudo guardar'); }
  };
  return (
    <label className="flex items-center gap-1.5 text-sm border rounded-lg px-2 h-9 bg-background" title="Aviso en el portal a cada persona antes de que empiece un evento con hora" data-testid="event-reminder-setting">
      <Bell className="w-4 h-4 text-muted-foreground" />
      <select value={value} onChange={(e) => change(Number(e.target.value))} className="bg-transparent outline-none text-sm" data-testid="event-reminder-select">
        {Object.entries(LABEL).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
      </select>
    </label>
  );
};
